import { h, defineComponent } from 'vue';
import { PaymentDetailsCallbacks, portalSection } from '@/services/chargebee/types';
import { t } from '@/ui/i18n/i18n';
import { box, button, pageSubtitle } from '@/ui/components';
import { paymentSourceUpdatedTask } from '@/services/chargebee/paymentSources';

export const PaymentDetails = defineComponent({
  name: 'PaymentDetails',
  setup(props, context) {
    const callbacks: PaymentDetailsCallbacks = {
      loaded: () => {
        //todo: add mixpanel and ga events
      },
      close: () => {
        //todo: add mixpanel and ga events
      },
      visit: (sectionType: string) => {
        //todo: add mixpanel and ga events
      },
      paymentSourceAdd: (status: string) => {
        if (status === 'success') {
          paymentSourceUpdatedTask.run();
        }
      },
      paymentSourceUpdate: (status: string) => {
        if (status === 'success') {
          paymentSourceUpdatedTask.run();
        }
      },
      paymentSourceRemove: (status: string) => {
        if (status === 'success') {
          paymentSourceUpdatedTask.run();
        }
      },
    };

    const showPaymentDetails = () => context.emit('click', {
      sectionType: portalSection.PAYMENT_SOURCES,
      callbacks,
    });

    return function render() {
      return box([
        pageSubtitle(t('subscription.payment-details')),
        h('p', { class: 'description' }, t('subscription.payment-info')),
        button(t('common.edit'), showPaymentDetails),
      ]);
    };
  },
});
